import AsyncStoreService from '../../services/async-store.service';
import {
  userAuthenticateApi,
  getTokenApi,
  ssoAuthenticateApi,
  userAuthenticateApiSSO,
  validateBxAuth,
  validateAAdvantageNo,
  forgotPasswordApi,
  checkAnswerApi,
  getNextQuestionApi,
} from '../../services/api/auth.service';
import { getTripCount } from '../actions/mytrips';
import { getProfileData } from '../actions/profile';
import * as WebBrowser from 'expo-web-browser';
import { logException } from '../../utils/logger.utils';
import { guestTokenUserName } from '../../constants/Configs';
import { openAlert } from './alert';
import * as SecureStore from 'expo-secure-store';
import * as Linking from 'expo-linking';
import { androidSSO, siteUrl, baseApiUrl } from '../../config/env';
import i18n from '../../i18n';
import { setExpenseResults } from './expense';
import { validateAuthNumber, isBXservice } from '../../utils/search.utils';

export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';
export const USER_AUTHENTICATE_SUCCESS = 'AUTHENTICATE_SUCCESS';
export const USER_AUTHENTICATE_START = 'USER_AUTHENTICATE_START';
export const SSO_AUTHENTICATE_START = 'SSO_AUTHENTICATE_START';
export const SSO_AUTHENTICATE_SUCCESS = 'SSO_AUTHENTICATE_SUCCESS';
export const SSO_AUTHENTICATE_FAILURE = 'SSO_AUTHENTICATE_FAILURE';
export const SSO_NOT_AVAILABLE = 'SSO_NOT_AVAILABLE';
export const USER_AUTHENTICATE_FAILURE = 'USER_AUTHENTICATE_FAILURE';
export const LOGOUT = 'LOGOUT';
export const SET_BXAUTH_VALIDATED = 'SET_BXAUTH_VALIDATED';
export const SET_IS_BX_CURRENCY_CULTURE = 'SET_IS_BX_CURRENCY_CULTURE';
export const SET_AADVANTAGE_NUMBER = 'SET_AADVANTAGE_NUMBER';
export const SET_DEEP_LINK = 'SET_DEEP_LINK';
export const CLEAR_DEEP_LINK = 'CLEAR_DEEP_LINK';

export const getTokenSuccess = (tokenData) => {
  return (dispatch) => {
    dispatch({ type: GET_TOKEN_SUCCESS, tokenData });
  };
};

export const userAuthenticateStart = () => {
  return (dispatch) => {
    dispatch({ type: USER_AUTHENTICATE_START });
  };
};
export const ssoAuthenticateStart = () => {
  return (dispatch) => {
    dispatch({ type: SSO_AUTHENTICATE_START });
  };
};

export const userAuthenticateFailure = () => {
  return (dispatch) => {
    dispatch({ type: USER_AUTHENTICATE_FAILURE });
  };
};

export const userAuthenticateSuccess = (user) => {
  return (dispatch) => {
    dispatch({ type: USER_AUTHENTICATE_SUCCESS, user });
    if (!user?.companyCultureConfigurations?.length === 0) {
      const [{ LanguageCode }] = user?.companyCultureConfigurations ?? [{}];
      LanguageCode && i18n.changeLanguage(LanguageCode);
    }
  };
};

export const ssoAuthenticateSuccess = () => {
  return (dispatch) => {
    dispatch({ type: SSO_AUTHENTICATE_SUCCESS });
  };
};

export const ssoNotAvailable = () => {
  return (dispatch) => {
    dispatch({ type: SSO_NOT_AVAILABLE });
  };
};
export const ssoAuthenticateFailure = () => {
  return (dispatch) => {
    dispatch({ type: SSO_AUTHENTICATE_FAILURE });
  };
};

export const getToken = (email, password, isSso = false, additionalInfo) => {
  return async (dispatch) => {
    try {
      const tokenData = await getTokenApi(email, password, isSso, additionalInfo);
      if (!tokenData.error) {
        dispatch(getTokenSuccess(tokenData));
        await AsyncStoreService.setUserName(email);
        await AsyncStoreService.setTokenData(tokenData);
      }
    } catch (error) {
      logException(error, {
        metaData: {
          siteUrl,
          email,
          isSso,
          password: password?.length,
          message: 'getTokenApi api failed',
        },
      });
    }
  };
};

export const getAAToken = async () => {
  const email = 'guest,' + baseApiUrl;
  const password = '';
  const isSso = false;
  return async (dispatch) => {
    try {
      const tokenData = await getTokenApi(email, password, isSso);
      if (!tokenData.error) {
        dispatch(getTokenSuccess(tokenData));
        await AsyncStoreService.setTokenData(tokenData);
      }
    } catch (error) {
      logException(error, {
        metaData: {
          siteUrl,
          email,
          isSso,
          password: password?.length,
          message: 'getTokenApi api failed',
        },
      });
    }
  };
};

export const userAuthenticateReload = () => {
  return async (dispatch) => {
    try {
      const userName = await AsyncStoreService.getUserName();
      if (userName !== 'guest') {
        dispatch(
          userAuthenticate({
            userName,
            password: 'SSO',
            isSso: true,
          })
        );
      }
    } catch (error) {
      dispatch(openAlert({ message: 'Failed to connect to server.' }));
      logException(error, {
        metaData: {
          message: 'SSO Failed to connect to server.',
        },
      });
    }
  };
};

const completeSSOAuthenticate = async (dispatch, userName) => {
  const response = WebBrowser.maybeCompleteAuthSession({
    skipRedirectCheck: true,
  });

  if (response?.type === 'failed') {
    const url = androidSSO + userName;
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
    } else {
      dispatch(
        openAlert({
          message: 'Close the browser is not possible, please try again',
        })
      );
    }
  }
};

export const userAuthenticate = ({
  userName,
  password,
  storeEmail,
  storePassword,
  bioAvailability,
  isSso = false,
  close = false,
}) => {
  return async (dispatch) => {
    dispatch(userAuthenticateStart());

    try {
      let userData = null;
      if (isSso && userName) {
        userData = await userAuthenticateApiSSO(userName, password);
      } else {
        userData = await userAuthenticateApi(userName, password);
      }
      if (userData?.error) {
        return userData;
      }
      if (!userData) {
        dispatch(userAuthenticateFailure());
        dispatch(openAlert({ message: i18n.t('login:UserAuthenticate.WrongUserCredentials') }));
        return;
      }
      await AsyncStoreService.setUserData(userData);

      if (close) {
        dispatch(userAuthenticateSuccess(userData));
        await completeSSOAuthenticate(dispatch, userName);
        return;
      }

      if (
        !isSso &&
        bioAvailability &&
        storePassword !== password &&
        storeEmail !== userName &&
        password
      ) {
        dispatch(
          openAlert({
            message: 'Remember my password and securely use biometrics to login in the future ?',
            confirmText: 'Yes',
            cancelText: 'No',
            onConfirmPressed: async () => {
              await SecureStore.setItemAsync('userName', userName);
              await SecureStore.setItemAsync('password', password);
            },
          })
        );
      }

      await dispatch(
        getToken(userName, password, isSso, `${userData.GroupKey},${userData.companyCode}`)
      );
      dispatch(userAuthenticateSuccess(userData));

      dispatch(getTripCount());
      await dispatch(getProfileData());
    } catch (error) {
      dispatch(userAuthenticateFailure());
      logException(error, {
        metaData: {
          message: 'Authentication Failed.',
          userName,
          storeEmail,
          password: storePassword?.length,
          bioAvailability,
        },
      });
    }
  };
};

export const ssoAuthenticate = (userName, password) => {
  return async (dispatch) => {
    dispatch(ssoAuthenticateStart());
    try {
      const sso = await ssoAuthenticateApi(userName, password);
      if (sso.companyCode) {
        dispatch(ssoAuthenticateSuccess());
        return sso;
      }
      if (
        sso.UserInformation != null &&
        sso.UserInformation != '' &&
        sso.UserInformation != undefined
      ) {
        dispatch(userAuthenticateFailure());
        return sso;
      }
      dispatch(ssoNotAvailable());
      return sso;
    } catch (error) {
      dispatch(ssoAuthenticateFailure());
      logException(error, {
        metaData: {
          message: 'Authentication Failed.',
          userName,
          password: password.length,
        },
      });
      return error;
    }
  };
};

export const setIsBXCurrencyCulture = (serviceType) => {
  return async (dispatch) => {
    const isBXCurrencyCulture = isBXservice(serviceType);
    dispatch({ type: SET_IS_BX_CURRENCY_CULTURE, isBXCurrencyCulture });
  };
};

export const logout = () => {
  return async (dispatch) => {
    AsyncStoreService.removeTokenData();
    AsyncStoreService.removeUserData();
    dispatch({ type: LOGOUT });
    await dispatch(getToken(guestTokenUserName, ''));
  };
};

export const bxAuthValidate = (data) => {
  return async (dispatch) => {
    const param = data;
    const bxAuthSuccess = await validateBxAuth(param);
    dispatch(
      openAlert({
        message: bxAuthSuccess.RejectReason,
      })
    );
  };
};

export const aadvantageValidate = (data) => {
  return async (dispatch) => {
    const res = await validateAAdvantageNo(data);
    dispatch({ type: SET_AADVANTAGE_NUMBER, res });
  };
};

export const forgotPassword = (id) => {
  return async () => {
    try {
      return await forgotPasswordApi(id);
    } catch (error) {
      logException(error, {
        metaData: {
          siteUrl,
          id,
          message: 'forgotPasswordApi api failed',
        },
      });
    }
  };
};

export const checkAnswer = (id, userAnswer, questionId, checkAnswer) => {
  return async () => {
    try {
      return await checkAnswerApi(id, userAnswer, questionId, checkAnswer);
    } catch (error) {
      logException(error, {
        metaData: {
          siteUrl,
          id,
          message: 'checkAnswerApi api failed',
        },
      });
    }
  };
};

export const getNextQuestion = (id) => {
  return async () => {
    try {
      return await getNextQuestionApi(id);
    } catch (error) {
      logException(error, {
        metaData: {
          siteUrl,
          id,
          message: 'getNextQuestionApi api failed',
        },
      });
    }
  };
};

export const setDeepLinkAction = (url) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_DEEP_LINK,
        payload: url,
      });
    } catch (error) {
      console.error('Deep link set error:', error);
    }
  };
};

export const clearDeepLinkAction = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CLEAR_DEEP_LINK,
      });
    } catch (error) {
      console.error('Deep link clear error:', error);
    }
  };
};
